import React from 'react'
import parse from 'html-react-parser'
import Link from '../utils/link'
import { RightArrow } from './icons'

const List = ({listItem, rightPosition}) => {

  return (
    <section className="list">
      <div className="list__inner content--left">
        {rightPosition && <div className="left--spacing"></div>}

        <div className="list__wrapper">
          {
            listItem.map((el, index) => (
              <div key={index} className="list__item">
                <h3>{el.heading}</h3>

                {parse(el.content)}

                { el.button?.url &&
                  <Link className='list__button' to={el.button.url}>
                    <span>{el.button.title}</span>
                    <RightArrow color={`#fff`} />
                  </Link>
                }
              </div>
            ))
          }
        </div>
      </div>
    </section>
  );
};

export default List;